<button
  type="button"
  class="serial-csv-upload"
  matTooltip="The device list exported from MagicInfo (.xls), or a CSV with a serial column"
  (click)="fileInput.click()"
  data-testId="serial-csv-upload">
  <mat-icon fontSet="material-symbols-outlined">upload_file</mat-icon>
  <span>Upload list</span>
</button>
<input #fileInput type="file" accept=".xls,.csv,.txt,application/vnd.ms-excel,text/csv,text/plain" hidden (change)="onFileSelected(fileInput)">
